"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdaptableLoadingScreen = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Dialog_1 = tslib_1.__importDefault(require("../../../components/Dialog"));
const rebass_1 = require("rebass");
class AdaptableLoadingScreen extends React.Component {
    render() {
        return (React.createElement(Dialog_1.default, { modal: true, isOpen: this.props.showLoadingScreen, onDismiss: this.props.onClose, showCloseButton: false, style: {
                minHeight: 'auto',
            } },
            React.createElement(rebass_1.Box, { padding: 3 },
                React.createElement("h4", null, "Initialising Grid"),
                React.createElement("p", null, "Retrieving your settings and setting up the grid..."))));
    }
}
exports.AdaptableLoadingScreen = AdaptableLoadingScreen;
